import { useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

export const useSmBreakpoint = () => {
  const theme = useMantineTheme();
  const mdBreakpoint = useMediaQuery(`(min-width: ${theme.breakpoints.sm})`);
  return mdBreakpoint;
};
